/* eslint-disable */

export const CommerceFulfillmentStatus = {
  Pending: 'pending',
  Succeeded: 'succeeded',
  Failed: 'failed',
  Compensated: 'compensated'
} as const;
export type CommerceFulfillmentStatus = typeof CommerceFulfillmentStatus[keyof typeof CommerceFulfillmentStatus];
